import { json } from "@remix-run/node"
import { Link, type MetaFunction, useLoaderData } from "@remix-run/react"

// Import all your MDX posts from the app/routes/_marketing+/resources directory
import NavigationApp from "../../../components/navigation-app"
import NavigationMarketing from "../../../components/navigation-marketing"
import { Button } from "../../../components/ui/button"

import { useOptionalUser } from "../../../utils/user"
import * as postChildhoodAllergyManagementGuide from "./childhood-allergy-management-guide.mdx"
import * as postChildhoodAnxietyManagementToolkit from "./childhood-anxiety-management-toolkit.mdx"
import * as postComprehensiveChildhoodSafetyPlan from "./comprehensive-child-safety-plan.mdx"
import * as postComprehensiveChildhoodNutritionPlanning from "./comprehensive-childhood-nutrition-planning.mdx"
import * as postCreatingChildDevelopmentPortfolio from "./creating-child-development-portfolio.mdx"
import * as postDigitalParentingTechnologyContracts from "./digital-parenting-technology-contracts.mdx"
import * as postEffectiveParentTeacherCommunication from "./effective-parent-teacher-communication.mdx"
import * as postEstatePlanning101ForParents from "./estate-planning-101-for-parents.mdx"
import * as postFamilyFitnessRoutinesAllAges from "./family-fitness-routines-all-ages.mdx"
import * as postFamilyMindfulnessTechniques from "./family-mindfulness-techniques.mdx"
import * as postHomeschoolingResourceManagement from "./homeschooling-resource-management.mdx"
import * as postInclusivePlaydatesPlanningGuide from "./inclusive-playdates-planning-guide.mdx"
import * as postMasterCoParentingCommunication from "./mastering-co-parenting-communication.mdx"
import * as postNavigatingParentalLeaveGuide from "./navigating-parental-leave-guide.mdx"
import * as postBilingualParentingStrategies from "./raising-bilingual-children-strategies.mdx"
import * as postRaisingMoneySmartKidsFinancialLiteracy from "./raising-money-smart-kids-financial-literacy.mdx"
import * as postSafeguardingChildIdentityProtection from "./safeguarding-child-identity-protection.mdx"
import * as postSleepTrainingMethodsComparison from "./sleep-training-methods-comparison.mdx"
import * as post529EducationPlans from "./ultimate-guide-529-education-plans.mdx"

function postFromModule(mod: any) {
	console.log("mod", mod.attributes.meta)
	return {
		slug: mod.filename.replace(/\.mdx?$/, ""),
		...mod.attributes.details,
	}
}

export async function loader() {
	return json([
		postFromModule(post529EducationPlans),
		postFromModule(postEstatePlanning101ForParents),
		postFromModule(postSafeguardingChildIdentityProtection),
		postFromModule(postNavigatingParentalLeaveGuide),
		postFromModule(postComprehensiveChildhoodNutritionPlanning),
		postFromModule(postDigitalParentingTechnologyContracts),
		postFromModule(postRaisingMoneySmartKidsFinancialLiteracy),
		postFromModule(postMasterCoParentingCommunication),
		postFromModule(postChildhoodAnxietyManagementToolkit),
		postFromModule(postBilingualParentingStrategies),
		postFromModule(postSleepTrainingMethodsComparison),
		postFromModule(postCreatingChildDevelopmentPortfolio),
		postFromModule(postInclusivePlaydatesPlanningGuide),
		postFromModule(postEffectiveParentTeacherCommunication),
		postFromModule(postFamilyMindfulnessTechniques),
		postFromModule(postFamilyFitnessRoutinesAllAges),
		postFromModule(postComprehensiveChildhoodSafetyPlan),
		postFromModule(postHomeschoolingResourceManagement),
		postFromModule(postChildhoodAllergyManagementGuide),
	])
}

export const meta: MetaFunction = () => [
	{
		title: "Present Parent AI | Resources",
		description:
			"Explore the resources available to help you plan for the future of your family – along with activities, .",
	},
]

export default function Index() {
	const posts = useLoaderData<typeof loader>()
	const user = useOptionalUser()

	return (
		<div>
			{user && <NavigationApp />}
			{!user && <NavigationMarketing />}
			<div className="grid grid-cols-1 gap-4 p-4 md:grid-cols-2 lg:grid-cols-3">
				{posts.map(post => (
					<div
						key={post.slug}
						className="overflow-hidden rounded-lg bg-secondary shadow-lg"
					>
						<div className="p-6">
							<h2 className="mb-2 text-xl font-bold">{post.title}</h2>
							{post.description && (
								<p className="text-base text-gray-700 dark:text-gray-300">
									{post.description}
								</p>
							)}
							<Link
								to={`./${post.slug}`}
								className="text-black no-underline dark:text-white"
							>
								<div className="flex justify-end">
									<Button variant="link" size="sm" className="ml-auto p-0">
										Read more
									</Button>
								</div>
							</Link>
						</div>
					</div>
				))}
			</div>
		</div>
	)
}
